import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconClose = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconClose"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="m12.044 14.285-9.2 9.183A1.64 1.64 0 0 1 1.666 24a1.5 1.5 0 0 1-1.133-.532 1.466 1.466 0 0 1 0-2.262l9.244-9.227L.49 2.75A1.619 1.619 0 0 1 1.622 0c.441.004.863.18 1.178.488L12 9.671 21.2.488A1.56 1.56 0 0 1 22.333 0c.441.004.863.18 1.178.488.313.321.488.752.49 1.2a1.58 1.58 0 0 1-.49 1.153l-9.2 9.183 9.2 9.227a1.618 1.618 0 0 1-1.133 2.75 1.42 1.42 0 0 1-1.089-.488z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconClose);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
